/**
 * Confirm-email-change: error model.
 *
 * No field errors here, unlike the request form next door: there is no field to
 * attach one to. Every failure is one message on one page, so the only work is
 * deciding whether the visitor can do something about it, and saying so.
 *
 * The backend's messages are user-facing copy written for exactly this page
 * (`ConfirmEmailChange.ts`) and pass through verbatim; rewriting them here would
 * create a second copy to keep in sync:
 *
 * - `401`: "Invalid or expired confirmation link. Please request the change again."
 *   Covers never-existed, already-used and expired as one answer, deliberately: a
 *   probe must not learn the difference between them.
 * - `409`: "This email address is now in use by another account." Someone claimed
 *   the address in between. Nothing was spent (the link is still live) so the way
 *   out is to cancel or re-request from the account page.
 */
import { classifyInfraError, type InfraFailure } from '@/utils/infra-error';

const FALLBACK_MESSAGE = 'This confirmation link could not be used.';

export type ConfirmEmailChangeError = InfraFailure;

export function toConfirmEmailChangeError(e: unknown): ConfirmEmailChangeError {
  return classifyInfraError(e, FALLBACK_MESSAGE);
}
